﻿
$(document).ready(function () {

    // init HomePage hero carousel...
    if (jQuery().slick && $('.text-slider')) {


        // attach an initialise event to remove the style attributes hiding any slide contentent
        $('.text-slider').on('init', function (e, s) {
            $('.text-slider .slide:not(:first)').removeAttr('style');
        })

        $('.text-slider').slick({
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 300,
            arrows: true,
            dots: true,
            dotsClass: 'carousel-dots',
            customPaging: function (slider, i) {
                return '<a href="#" class="carousel-dot"></a>';
            },
            prevArrow: '<button type="button" class="slick-prev mf mf-corp-arrow-left"></button>',
            nextArrow: '<button type="button" class="slick-next mf mf-corp-arrow-right"></button>'
        });
    }
})